import { fmtDateFull } from "@/lib/format";
import { cn } from "@/lib/utils";

const TONE = {
  created: "border-cyan-500", inbound_reply: "border-cyan-500", assigned: "border-blue-500", reassigned: "border-amber-500", work_started: "border-emerald-500",
  work_paused: "border-slate-400", closure_requested: "border-purple-500", closure_approved: "border-purple-500", closure_rejected: "border-red-500",
  closed: "border-slate-500", reopened: "border-blue-500", note_added: "border-amber-400", reply_sent: "border-blue-400", attachment_added: "border-cyan-400",
  tagged: "border-slate-400", rotting_alert: "border-red-500", restored: "border-cyan-500",
};

export default function Timeline({ events }) {
  return (
    <ol className="audit-rail space-y-4" data-testid="ticket-history">
      {[...events].reverse().map((e) => (
        <li key={e.id} className="relative" data-testid={`event-${e.type}`}>
          <div className="flex flex-wrap items-baseline gap-x-2">
            <span className={cn("mono border-l-2 pl-1.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground", TONE[e.type] || "border-border")}>{e.type.replace(/_/g, " ")}</span>
            <span className="mono text-[11px] text-muted-foreground">{fmtDateFull(e.at)}</span>
            <span className="text-[11px] text-muted-foreground">by {e.actor?.name || "system"}{e.actor?.impersonator ? ` (as viewed by ${e.actor.impersonator.name})` : ""}</span>
          </div>
          <div className="mt-0.5 text-sm">{e.summary}</div>
          {e.details?.tag && <div className="mono mt-0.5 text-[11px] text-amber-500">tag: {e.details.tag}</div>}
          {e.details?.recipients?.length > 0 && <div className="mono mt-0.5 text-[11px] text-muted-foreground">emailed: {e.details.recipients.join(", ")}</div>}
        </li>
      ))}
    </ol>
  );
}
